/* eslint-disable */
export default {
  loginButton: 'Iniciar sessão',
  signupButton: 'É um novo utilizador? Inscreva-se',
  version: 'Versão',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
